import React, { useState, useEffect } from 'react';
import { Skeleton } from './Skeleton';
import { ToggleSwitch } from './ToggleSwitch';
import { isTauri } from '../utils/tauri';
import {
  getCachedDeviceId,
  getDevicePreference,
  updateNotifyPreference,
} from '../services/deviceService';

/**
 * 로그아웃 상태에서도 익명 알림 수신 토글 (Tauri 전용)
 * - 기본 ON (로그인 시 device 등록 시점에 백엔드 default TRUE)
 * - 백엔드 device_tokens.notify_enabled를 토글
 * - localStorage 캐시도 동시 갱신 → 로그아웃 즉시 반영
 */
export const LogoutNotificationToggle: React.FC = () => {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (!isTauri()) {
      setLoading(false);
      return;
    }
    const deviceId = getCachedDeviceId();
    if (!deviceId) {
      setLoading(false);
      return;
    }
    getDevicePreference(deviceId)
      .then((pref) => {
        setEnabled(pref.notifyEnabled);
      })
      .catch((err) => {
        console.warn('[LogoutNotifyToggle] preference fetch failed:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleToggle = async () => {
    const deviceId = getCachedDeviceId();
    if (!deviceId || updating) return;
    const next = !enabled;
    setUpdating(true);
    try {
      await updateNotifyPreference(deviceId, next);
      setEnabled(next);
    } catch (err) {
      console.error('[LogoutNotifyToggle] update failed:', err);
    } finally {
      setUpdating(false);
    }
  };

  if (!isTauri()) return null;
  if (loading) return <div className="flex items-center gap-3 px-3 py-2.5" aria-hidden="true"><Skeleton className="h-4 w-4 rounded" /><Skeleton className="h-3.5 w-40" /></div>;

  return (
    <ToggleSwitch
      checked={enabled}
      onChange={handleToggle}
      disabled={updating}
      label="로그아웃 시에도 알림 받기"
      description="로그아웃 후 새 메시지 도착 시 익명 알림 표시 (발신자/내용 비공개)"
    />
  );
};
